import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHandHoldingDollar, faMagnifyingGlass, faXmark, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faCreditCard } from '@fortawesome/free-regular-svg-icons'
import Select from "react-select";
import Modal from 'react-modal';
import { useUser } from "../utils/UserContext";
import { getCurrencySymbol, formatCurrency } from '../utils/currencyUtils';
import { Toaster, toast } from 'react-hot-toast';

//FILE UPLOAD
import { FilePond, registerPlugin } from 'react-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css'
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

function Deposit() {
  const { user } = useUser();
  const [files, setFiles] = useState([])
  const [fileName, setFileName] = useState()
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [deposithistorys, setDeposithistorys] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const filteroptions = [
    { value: "all", label: "All" },
    { value: "confirmed", label: "Confirmed" },
    { value: "pending", label: "Pending" },
    { value: "Failed", label: "failed" },
  ];
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const filteredHistory = deposithistorys.filter(deposithistory => 
    Object.values(deposithistory).some(value => 
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) && 
    (selectedFilter === 'all' || deposithistory.status.toLowerCase() === selectedFilter.toLowerCase())
  )
  const typeoptions = [
    { value: "crypto", label: "Crypto" },
  ];
  const [methodoptions, setMethodoptions] = useState([]);
  const [type, setType] = useState("crypto");
  const [method, setMethod] = useState("bitcoin");
  const [address, setAddress] = useState();
  const [amount, setAmount] = useState();
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const handleCopy = async () => {
      if (!address) return;
      try {
          await navigator.clipboard.writeText(address);
          toast.success('Copied to Clipboard!')
      } catch (err) {
          console.error("Failed to copy: ", err);
      }
  };
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchdeposit: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setDeposithistorys(data.trans);
      }
    })
    .catch(err => {
      toast.error('Error fetching deposit transaction!')
    })
  }, [user]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchaddress: true })
    })
    .then(response =>  response.json())
    .then(data => {
      const methodop = []
      if (data.status === "success") {
        data.address.forEach(address => {
          methodop.push({
            value: address.value,
            logo: address.logo,
            label: (
              <>
                <img src={address.logo} alt={address.symbol} width="20" style={{ marginRight: 5 }} />
                {address.value}
              </>
            ),
            address: address.address,
            symbol: address.symbol
          });
        });
        setMethodoptions(methodop);
      }
    })
    .catch(err => {
      console.error('Error fetching deposit wallet:', err);
    })
  }, [user]);
  useEffect(() => {
    if(type && method && amount && fileName){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [type, method, amount, fileName]);
  const ValidateDeposit = () =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/deposit.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_deposit: true, amount: amount, proof: fileName, method: method })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setLoading(false);
        setIsOpen(false);
        toast.success(data.result);
        setTimeout(() => {
          window.location.href = "dashboard";
        }, 2000);
      }else{
        toast.error(data.message);
        setLoading(false);
      }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
      toast.error('There was an issue processing your deposit.')
    })
  }
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div><Toaster/></div>
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Deposit" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Deposit" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
                <div className="col-12">
                    <div className="mycard mt-2" style={{minHeight: '88vh'}}>
                        <div className="d-lg-flex align-items-center justify-content-between mb-4">
                            <div className="d-flex align-items-center">
                                <h6 className="mb-0 text-light fw-bold" style={{fontSize: '18px'}}>Deposits</h6>
                                <div className="myBtn ms-3 bg-prime px-3" onClick={() => setIsOpen(true)}><FontAwesomeIcon className="me-1" icon={faCreditCard} style={{fontSize: '16px'}} /> Deposit now</div>
                            </div>
                            <div className="d-flex align-items-center mt-2 mt-lg-0">
                                <div className="d-flex align-items-center form-control justify-content-between me-2 searchcon">
                                    <FontAwesomeIcon className="me-2" icon={faMagnifyingGlass} style={{fontSize: '16px'}} />
                                    <input 
                                    type="text" 
                                    placeholder="Search for deposits" 
                                    className="searchinput"
                                    value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                                <Select 
                                    options={filteroptions}
                                    value={filteroptions.find((opt) => opt.value === selectedFilter)}
                                    onChange={(e) => setSelectedFilter(e.value)}
                                    styles={darkThemeStyles}
                                    className="w-full"
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-borderless table-dark align-middle">
                                <thead>
                                    <tr className="fs-7">
                                    <th className="fw-normal text-light" style={{width: '150px'}}>Date</th>
                                    <th className="fw-normal text-light">Reference</th>
                                    <th className="fw-normal text-light">Method</th>
                                    <th className="fw-normal text-light">Type</th>
                                    <th className="fw-normal text-light">Amount</th>
                                    <th className="fw-normal text-light">Status</th>
                                    </tr>
                                </thead>
                                <tbody style={{fontSize: '14px'}}>
                                {filteredHistory.length > 0 ? (
                                    filteredHistory.map((history) => (
                                        <tr>
                                            <td>{history.date}</td>
                                            <td>{history.hash}</td>
                                            <td>{history.method}</td>
                                            <td>{history.type}</td>
                                            <td>{getCurrencySymbol(user?.currency)}{formatCurrency(history.amount)}</td>
                                            <td>{history.status.charAt(0).toUpperCase() + history.status.slice(1)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td className="py-5" colSpan={7}>You have not made any deposits yet, <span className="text-prime" onClick={() => setIsOpen(true)}>Click here to make a deposit.</span></td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => setIsOpen(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Deposit</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <p className="my-3 text-light fw-semibold" style={{fontSize: '15px'}}>To make a deposit, choose your preferred method, enter an amount and upload a corresponding payment proof.</p>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
            <Select 
                options={typeoptions} 
                value={typeoptions.find((opt) => opt.value === type)}
                onChange={(e) => setType(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Method:</label>
            <Select 
                options={methodoptions} 
                value={methodoptions.find((opt) => opt.value === method)}
                onChange={(selected) => {
                    setMethod(selected.value); 
                    setAddress(selected.address);
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Address:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                  type="text"
                  readOnly
                  className="inputNone"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                <div className="fw-bold text-white" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}} onClick={handleCopy}>Copy</div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input 
                  type="number"
                  placeholder="0.00000000"
                  className="inputNone"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer'
                  }}
                >
                  {user?.currency}
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Payment Proof:</label>
            <FilePond
              files={files}
              onupdatefiles={setFiles}
              allowMultiple={false}
              maxFiles={3}
              name="file"
              labelIdle="Click here to upload payment proof"
              server={{
                process: (fieldName, file, metadata, load, error, progress, abort) => {
                  const formData = new FormData();
                  formData.append("file", file);
                  const request = new XMLHttpRequest();
                  request.open("POST", `${process.env.REACT_APP_API_URL}controller/upload.php`);
                  request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                  };
                  request.onload = () => {
                    const res = JSON.parse(request.responseText);
                    if (res.success) {
                      setFileName(res.filename);
                      load(res.filename);
                    } else {
                      error(res.error || "Upload failed");
                    }
                  };
                  request.onerror = () => {
                    error("Upload error");
                  };
                  request.send(formData);
                  return {
                    abort: () => {
                      request.abort();
                      abort();
                    }
                  };
                },
                revert: (serverId, load, error) => {
                  fetch(`${process.env.REACT_APP_API_URL}controller/delete.php`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ filename: fileName })
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.success) {
                        setFileName("");
                        setFiles([]);
                        load();
                      } else {
                        error(data.error || "Failed to delete file");
                      }
                    })
                    .catch(() => {
                      error("Delete request failed");
                    });
                }
              }}
            />
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateDeposit : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Deposit'}</div>
        </Modal>
      </div>
    </div>
  )
}
export default Deposit